{
  "auth": {
    "agree": "Я согласен с",
    "createAccount": "Создать аккаунт",
    "createNewAccount": "Создать новый аккаунт",
    "email": "Электронная почта",
    "login": "Вход",
    "password": "Пароль",
    "recover_password": "Восстановить пароль",
    "sign_up": "Регистрация",
    "keep_logged_in": "Оставаться в системе",
    "termsOfUse": "Условиями использования.",
    "reset_password": "Сбросить пароль"
  },
  "404": {
    "title": "Эта страница ушла на рыбалку.",
    "text": "Если вы считаете, что это ошибка, пожалуйста, напишите нам на ",
    "back_button": "Вернуться в панель управления"
  },
  "typography": {
    "primary": "Основные стили текста",
    "secondary": "Второстепенные стили текста"
  },
  "dashboard": {
    "versions": "Версии",
    "setupRemoteConnections": "Настройка удаленных подключений",
    "currentVisitors": "Текущие посетители",
    "navigationLayout": "Макет навигации",
    "topBarButton": "Верхняя панель",
    "sideBarButton": "Боковая панель"
  },
  "language": {
    "brazilian_portuguese": "Португальский",
    "english": "Английский",
    "spanish": "Испанский",
    "simplified_chinese": "Китайский (упрощенный)",
    "persian": "Персидский"
  },
  "menu": {
    "auth": "Авторизация",
    "buttons": "Кнопки",
    "timelines": "Временные шкалы",
    "dashboard": "Панель управления",
    "orders": "Заказы",
    "services": "Услуги",
    "loyalty": "Программа лояльности",
    "clients": "Клиенты",
    "feedbacks": "Отзывы",
    "billing": "Биллинг",
    "login": "Вход",
    "preferences": "Настройки аккаунта",
    "marketing": "Маркетинг",
    "payments": "Платежи",
    "settings": "Настройки сайта",
    "pricing-plans": "Тарифные планы",
    "payment-methods": "Методы оплаты",
    "signup": "Регистрация",
    "recover-password": "Восстановление пароля",
    "recover-password-email": "Email для восстановления пароля",
    "404": "404",
    "faq": "FAQ",
    "users": "Пользователи",
    "projects": "Проекты"
  },
  "messages": {
    "all": "Все сообщения",
    "new": "Новые сообщения от {name}",
    "mark_as_read": "Отметить как прочитанное"
  },
  "navbar": {
    "messageUs": "Вопросы по веб-разработке:",
    "repository": "Репозиторий GitHub"
  },
  "notifications": {
    "all": "Все уведомления",
    "less": "Свернуть уведомления",
    "mark_as_read": "Прочитать",
    "sentMessage": "отправил(а) вам сообщение",
    "uploadedZip": "загрузил(а) новый Zip-файл с {type}",
    "startedTopic": "создал(а) новую тему",
    "empty": "Нет уведомлений"
  },
  "user": {
    "language": "Сменить язык",
    "logout": "Выйти",
    "profile": "Профиль",
    "settings": "Настройки",
    "billing": "Биллинг",
    "faq": "FAQ",
    "helpAndSupport": "Помощь и поддержка",
    "projects": "Проекты",
    "account": "Аккаунт",
    "explore": "Обзор"
  },
  "treeView": {
    "basic": "Базовый",
    "icons": "Иконки",
    "selectable": "Выбираемый",
    "editable": "Редактируемый",
    "advanced": "Продвинутый"
  },
  "chat": {
    "title": "Чат",
    "sendButton": "Отправить"
  },
  "spacingPlayground": {
    "value": "Значение",
    "margin": "Внешний отступ (Margin)",
    "padding": "Внутренний отступ (Padding)"
  },
  "spacing": {
    "title": "Отступы"
  },
  "cards": {
    "cards": "Карточки",
    "fixed": "Фиксированные",
    "floating": "Плавающие",
    "contentText": "Уникальные полоски зебр делают их одними из самых узнаваемых животных для людей.",
    "contentTextLong": "Уникальные полоски зебр делают их одними из самых узнаваемых животных для людей. Они встречаются в различных средах обитания, таких как саванны, редколесья, колючие кустарники, горы и прибрежные холмы. Различные антропогенные факторы оказали серьезное влияние на популяции зебр, в частности охота из-за шкур и разрушение среды обитания.",
    "rowHeight": "Высота строки",
    "title": {
      "default": "По умолчанию",
      "withControls": "С элементами управления",
      "customHeader": "Пользовательский заголовок",
      "withoutHeader": "Без заголовка",
      "withImage": "С изображением",
      "withTitleOnImage": "С заголовком на изображении",
      "withCustomTitleOnImage": "С кастомным заголовком на фото",
      "withStripe": "С полосой",
      "withBackground": "С фоном"
    },
    "button": {
      "main": "Главная",
      "cancel": "Отмена",
      "showMore": "Показать больше",
      "readMore": "Читать далее"
    },
    "link": {
      "edit": "Редактировать",
      "setAsDefault": "Сделать по умолчанию",
      "delete": "Удалить",
      "traveling": "Путешествия",
      "france": "Франция",
      "review": "Обзор",
      "feedback": "Оставить отзыв",
      "readFull": "Читать статью полностью",
      "secondaryAction": "Вторичное действие",
      "action1": "Действие 1",
      "action2": "Действие 2"
    }
  },
  "colors": {
    "themeColors": "Цвета темы",
    "extraColors": "Дополнительные цвета",
    "gradients": {
      "basic": {
        "title": "Градиенты кнопок"
      },
      "hovered": {
        "title": "Градиенты при наведении",
        "text": "Осветление на 15% применяется к оригинальному стилю для состояния наведения."
      },
      "pressed": {
        "title": "Градиенты при нажатии",
        "text": "Затемнение на 15% применяется к оригинальному стилю для нажатого состояния."
      }
    }
  },
  "tabs": {
    "alignment": "Выравнивание вкладок",
    "overflow": "Переполнение вкладок",
    "hidden": "Вкладки со скрытым слайдером",
    "grow": "Растягивающиеся вкладки"
  },
  "helpAndSupport": "Помощь и поддержка",
  "aboutVuesticAdmin": "О Vuestic Admin",
  "supportAndConsulting": "Поддержка и консалтинг",
  "search": {
    "placeholder": "Поиск..."
  },
  "buttonSelect": {
    "dark": "Темная",
    "light": "Светлая"
  },
  "vuestic": {
    "search": "Поиск",
    "noOptions": "Ничего не найдено",
    "ok": "ОК",
    "cancel": "Отмена",
    "uploadFile": "Загрузить файл",
    "undo": "Отменить",
    "dropzone": "Перетащите файлы сюда для загрузки",
    "fileDeleted": "Файл удален",
    "closeAlert": "Закрыть уведомление",
    "backToTop": "Наверх",
    "toggleDropdown": "Открыть список",
    "carousel": "Карусель",
    "goPreviousSlide": "Предыдущий слайд",
    "goNextSlide": "Следующий слайд",
    "goSlide": "Перейти к слайду {index}",
    "slideOf": "Слайд {index} из {length}",
    "close": "Закрыть",
    "openColorPicker": "Открыть выбор цвета",
    "colorSelection": "Выбор цвета",
    "colorName": "Цвет {color}",
    "decreaseCounter": "Уменьшить",
    "increaseCounter": "Увеличить",
    "selectAllRows": "Выбрать все строки",
    "sortColumnBy": "Сортировать колонку по {name}",
    "selectRowByIndex": "Выбрать строку {index}",
    "resetDate": "Сбросить дату",
    "nextPeriod": "Следующий период",
    "switchView": "Переключить вид",
    "previousPeriod": "Предыдущий период",
    "removeFile": "Удалить файл",
    "reset": "Сброс",
    "pagination": "Пагинация",
    "goToTheFirstPage": "На первую страницу",
    "goToPreviousPage": "На предыдущую страницу",
    "goToSpecificPage": "На страницу {page}",
    "goToSpecificPageInput": "Введите номер страницы",
    "goNextPage": "На следующую страницу",
    "goLastPage": "На последнюю страницу",
    "currentRating": "Текущий рейтинг {value} из {max}",
    "voteRating": "Оценить на {value} из {max}",
    "optionsFilter": "Фильтр опций",
    "splitPanels": "Разделенные панели",
    "movePaginationLeft": "Сдвинуть пагинацию влево",
    "movePaginationRight": "Сдвинуть пагинацию вправо",
    "resetTime": "Сбросить время",
    "closeToast": "Закрыть уведомление",
    "selectedOption": "Выбранная опция",
    "noSelectedOption": "Опция не выбрана",
    "breadcrumbs": "Навигационная цепочка",
    "counterValue": "Значение счетчика",
    "selectedDate": "Выбранная дата",
    "selectedTime": "Выбранное время",
    "progressState": "Состояние прогресса",
    "color": "Цвет",
    "next": "Далее",
    "back": "Назад",
    "finish": "Завершить",
    "step": "Шаг",
    "progress": "Прогресс",
    "loading": "Загрузка",
    "sliderValue": "Текущее значение слайдера: {value}",
    "switch": "Переключатель",
    "inputField": "Поле ввода",
    "fileTypeIncorrect": "Некорректный тип файла",
    "select": "Выберите опцию"
  }
}
